import Bits from '../../../bits';
import Modules from '../../../modules';

class SectionController {

	types = ['bit', 'module'];

	bits = Bits;
	modules = Modules;

	attributes = {
		index: 'data-section-index',
		uri: 'data-section-uri'
	};

	status = {
		initialized: 'initialized',
		pending: 'pending',
		done: 'done',
		failed: 'failed',
		removed: 'removed'
	};

	colors = {
		[this.status.initialized]: '#00ffff',
		[this.status.pending]: '#ffff00',
		[this.status.done]: '#00ff00',
		[this.status.failed]: '#ff0000',
		[this.status.removed]: '#666666'
	};

	monit = false;

	container;

	globals = [];

	pages = {};

	initialize(container) {
		this.container = container;
	}

	async #constructGlobalSections(scope) {
		this.#queryElements(scope, (type, selector, el) => {
			if (!this.container.contains(el)) {
				const index = this.globals.length;

				this.globals.push({
					type,
					el,
					uri: null,
					index,
					class: null,
					status: null
				});

				const section = this.globals[index];

				// section.el.setAttribute(this.attributes.index, index);

				this.#setSectionStatus(section, this.status.initialized);

				try {
					section.class = new this[`${type}s`][selector](el, null, index);
				} catch (e) {
					this.#setSectionStatus(section, this.status.failed);
					console.warn(e); // eslint-disable-line no-console
				}
			}
		});
	}

	#initializeGlobalSections() {
		for (const section of this.globals) {
			if (section.status === this.status.initialized) {
				try {
					this.#checkInitialize(section);
				} catch (e) {
					this.#setSectionStatus(section, this.status.failed);
					console.warn(e); // eslint-disable-line no-console
				}
			}
		}
	}

	async #constructPageSections(scope, uri) {
		this.#queryElements(scope, (type, selector, el) => {
			const index = this.pages[uri].length;

			this.pages[uri].push({
				type,
				el,
				uri,
				index,
				class: null,
				status: null
			});

			const section = this.pages[uri][index];

			// section.el.setAttribute(this.attributes.index, section.index);
			// section.el.setAttribute(this.attributes.uri, uri);

			this.#setSectionStatus(section, this.status.initialized);

			try {
				section.class = new this[`${type}s`][selector](el, uri, index);
			} catch (e) {
				this.#setSectionStatus(section, this.status.failed);
				console.warn(e); // eslint-disable-line no-console
			}
		});
	}

	#initializePageSections(uri) {
		for (const section of this.pages[uri]) {
			if (section.status === this.status.initialized) {
				try {
					this.#checkInitialize(section);
				} catch (e) {
					this.#setSectionStatus(section, this.status.failed);
					console.warn(e); // eslint-disable-line no-console
				}
			}
		}
	}

	#setSectionStatus(section, status) {
		section.status = document.body.contains(section.el) ? this.status[status] : this.status.removed;
		if (this.monit && this.monit.includes(status)) {
			// console.log(`${section.uri || 'global'} [${section.index}] ${section.el.classList} %c ${section.status}`, `color: ${this.colors[section.status]}`); // eslint-disable-line no-console
		}
	}

	#checkInitialize = (section) => {
		if (section.class.initialize) {
			this.#setSectionStatus(section, this.status.pending);
			section.class.initialize().then(() => {
				this.#setSectionStatus(section, this.status.done);
			}).catch((e) => {
				this.#setSectionStatus(section, this.status.failed);
				console.warn(e); // eslint-disable-line no-console
			});
		} else {
			this.#setSectionStatus(section, this.status.done);
		}
	}

	#checkDestroy(index, uri) {
		const section = uri ? this.pages[uri][index] : this.globals[index];
		if (section.class) {
			if (section.class.destroy) {
				try {
					section.class.destroy();
				} catch (e) {
					console.warn('Section failed to be destroyed', section, e); // eslint-disable-line no-console
				}
			} else {
				console.warn('Missing destroy function!', section); // eslint-disable-line no-console
			}
			delete section.class;
		} else {
			console.warn('Class missing', section); // eslint-disable-line no-console
		}
	}

	#queryElements(scope, callback) {
		// bits & modules
		for (const type of this.types) {
			// section class selector
			for (const selector in this[`${type}s`]) {
				// all elements with matching selector
				const els = scope.querySelectorAll(`.${selector}`);
				for (const el of els) {
					if (!el.hasAttribute(this.attributes.index)) callback(type, selector, el);
				}
			}
		}
	}

	async seekInitialize(scope = document, uri) {
		if (uri) {
			if (!this.pages[uri]) this.pages[uri] = [];
			await this.#constructPageSections(scope, uri);
			this.#initializePageSections(uri);
		} else {
			await this.#constructGlobalSections(scope);
			this.#initializeGlobalSections();
		}
	}

	destroyPage(uri) {
		if (this.pages[uri]) {
			for (let i = 0, l = this.pages[uri].length; i < l; ++i) this.#checkDestroy(i, uri);
			delete this.pages[uri];
		}
	}

	seekDestroy(el) {
		const sections = el.querySelectorAll(`[${this.attributes.index}]`);
		for (const section of sections) {
			const index = section.getAttribute(this.attributes.index);
			const uri = section.getAttribute(this.attributes.uri);
			this.#checkDestroy(index, uri);
		}
	}

	find(el) {
		if (el) {
			const index = el.getAttribute(this.attributes.index);
			const uri = el.getAttribute(this.attributes.uri);
			return uri ? this.pages[uri][index] : this.globals[index];
		}
	}

	class(section) {
		return new Promise((resolve) => {
			const found = this.find(document.querySelector(`.${section.selector}`));
			if (found && found.class) resolve(found.class);
		});
	}

	classSync(section) {
		const found = this.find(document.querySelector(`.${section.selector}`));
		if (found && found.class) return found.class;
	}

}

export default new SectionController();
